/** A page card: `surface` over `cardline`, carrying sh1 (design L3). */
import React from 'react';
import {StyleProp, StyleSheet, View, ViewStyle} from 'react-native';

import {RADIUS, SPACE} from '../theme/tokens';
import {useV2Theme} from '../theme/useV2Theme';

/** the design's card padding: 22 vertical, 24 horizontal */
const PAD_V = 22;

function Card({
  children,
  style,
}: {
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
}) {
  const tokens = useV2Theme(s => s.tokens);
  return (
    <View
      style={[
        styles.card,
        {
          backgroundColor: tokens.surface,
          borderColor: tokens.cardline,
          boxShadow: tokens.sh1,
        } as any,
        style,
      ]}>
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    borderRadius: RADIUS.card,
    borderWidth: 1,
    padding: PAD_V,
    paddingHorizontal: SPACE.xxl,
    gap: SPACE.lg,
  },
});

export default React.memo(Card);
